export const generateData = (accountsSpend) =>
	accountsSpend
		.sort((accA, accB) => accA.productName.localeCompare(accB.name))
		.map((accountSpend) => [
			accountSpend.productName,
			accountSpend.totalSpend,
			accountSpend.totalLeads,
			(accountSpend.totalSpend / accountSpend.totalLeads).toFixed(2),
		]);
